import { Box, darken } from '@material-ui/core';
import React from 'react';
import { alpha, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface CardNoteProps {
  note: string;
  highlight?: boolean;
  highlightWarning?: boolean;
  highlightPink?: boolean;
}

const CardNote = ({ note, highlight, highlightWarning, highlightPink }: CardNoteProps) => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.root, {
        [classes.highlightWarning]: highlightWarning,
        [classes.highlight]: highlight,
        [classes.highlightPink]: highlightPink,
      })}
    >
      <span>{note}</span>
    </Box>
  );
};

export const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '0.75em',
    padding: '0.125em 0.25em',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'inherit',
    lineHeight: 1.2,
    backgroundColor: alpha(theme.palette.warning.main, 0.15),
    color: darken(theme.palette.warning.main, 0.85),
    textAlign: 'center',
  },
  highlightPink: {
    backgroundColor: 'rgb(255, 142, 161, 75%)',
  },
  highlightWarning: {
    backgroundColor: theme.palette.warning.light,
  },
  highlight: {
    backgroundColor: '#00A7F7',
  },
}));

export default CardNote;
